import { Controller } from "@hotwired/stimulus";
import "./component.scss";

export default class extends Controller {
  static targets = ["slider", "next", "prev"];

  connect() {
    this.calculateSlideSettings();

    this.sliderTarget.addEventListener(
      "scroll",
      this.updateButtonStates.bind(this)
    );

    window.addEventListener("resize", this.calculateSlideSettings.bind(this));

    this.updateButtonStates();
  }

  disconnect() {
    this.sliderTarget.removeEventListener(
      "scroll",
      this.updateButtonStates.bind(this)
    );

    window.removeEventListener(
      "resize",
      this.calculateSlideSettings.bind(this)
    );
  }

  calculateSlideSettings() {
    const remInPx = parseFloat(
      getComputedStyle(document.documentElement).fontSize
    );

    const remValue = 20 * remInPx;
    const vwValue = window.innerWidth * 0.7;

    this.slideWidth = Math.min(remValue, vwValue);
    this.gap = 1 * remInPx;

    const totalSlideWidth = this.slideWidth + this.gap;
    const visibleWidth = this.sliderTarget.clientWidth;

    this.slidesToMove = Math.max(1, Math.floor(visibleWidth / totalSlideWidth));
  }

  updateButtonStates() {
    const scrollLeft = this.sliderTarget.scrollLeft;
    const clientWidth = this.sliderTarget.clientWidth;
    const scrollWidth = this.sliderTarget.scrollWidth;

    const isAtStart = scrollLeft <= 0;
    const isAtEnd = Math.abs(scrollLeft + clientWidth - scrollWidth) <= 1;

    // Buttons ausblenden oder einblenden
    this.prevTarget.style.display = isAtStart ? "none" : "";
    this.nextTarget.style.display = isAtEnd ? "none" : "";
  }

  next() {
    const currentScroll = this.sliderTarget.scrollLeft;
    const slideWidth = this.slideWidth + this.gap;
    const newScroll = Math.round(
      currentScroll + slideWidth * this.slidesToMove
    );

    this.sliderTarget.scrollTo({
      left: newScroll,
      behavior: "smooth",
    });
  }

  prev() {
    const currentScroll = this.sliderTarget.scrollLeft;
    const slideWidth = this.slideWidth + this.gap;
    const newScroll = Math.round(
      currentScroll - slideWidth * this.slidesToMove
    );

    this.sliderTarget.scrollTo({
      left: newScroll,
      behavior: "smooth",
    });
  }
}
